import React, { useContext, useEffect, useState } from "react";
import Image from 'next/image';
import { Container } from '../../../styles/agency-page-style';
import freshArtsLogo from '../../../public/images/assets/fresharts_logo.png';
import { categoriesList } from ".";
import { ArtistSearchProvider } from "../../../contexts/typesense/ArtistSearchContext";
import { Configure, Hits } from 'react-instantsearch-dom';
import { useRouter } from "next/router";
import UseWindowSize from "../../../hooks/helper/useWindowSize";
import DebouncedSearchBoxArtist from "../../../components/allArtists/debounced-search-artist";
import { BsSearch } from "react-icons/bs";
import InfiniteHits from "../../../components/allArtists/infinite-hits";
import { CustomHierarchicalMenuArtists } from "../../../components/allArtists/hierarchical-menu-artist";
import { ArtistContext } from "../../../contexts/ArtistContext";
import Link from "next/link";
import allArtistBanner from '../../../public/images/assets/allArtistBanner.webp';
import freshArtsBanner from '../../../public/images/assets/artist-bg.jpg';

import { fleatoConfig } from "../../../fleato-config";
import { Agency } from "../../../models/agency";

export default function AgencyPage({agency}: {agency: Agency}) {
    const router = useRouter();
    const screenProps = UseWindowSize();
    const { windowSize } = screenProps;
    const [showMenu, setShowMenu] = useState(false);
    const agencyId = router?.query?.id as string;
    const [currentSelectedCategory, setCurrentSelectedCategory] = useState("");
    const [facetFilters, setFacetFilters] = useState<string[]>([]);
    const { isSeller } = useContext(ArtistContext);

    useEffect(() => {
        if (agencyId?.length > 0) {
            if (!facetFilters?.includes(`agencyIds:${agencyId}`))
                setFacetFilters(prev => [...prev, `agencyIds:${agencyId}`])
        }
    }, [agencyId])

    // useEffect(() => {
    //     if (currentSelectedCategory?.length === 0) {
    //         setFacetFilters(prev => [...prev?.filter(item => !item?.includes("categoryHierarchy.lvl0"))]);
    //     } else {
    //         setFacetFilters(prev => [...prev.filter(pk => !pk?.includes(`categoryHierarchy.lvl0`)), `categoryHierarchy.lvl0:${currentSelectedCategory}`])
    //     }
    // }, [currentSelectedCategory])
    

    return (
        <ArtistSearchProvider searchScope={"artists"}>
            <Container>
                <div className='home-banner position-relative' style={{ backgroundImage: `url(${agencyId == 'fresharts' ? freshArtsBanner.src : allArtistBanner.src})` }}>
                    <div className='nav-container py-5'>
                        <div className='container'>
                            <div className='nav aside-menu p-0 bg-white bg-lg-transparent col-12 col-md-4 col-lg-9 d-lg-flex justify-content-end'
                                style={windowSize.width < 768 ?
                                    {
                                        position: 'absolute',
                                        transition: 'all 1s',
                                        zIndex: 10,
                                        height: '100%',
                                        width: '70%',
                                        transform: windowSize.width < 768 ? 'translateY(-45px)' : 'none',
                                        left: showMenu ? '0' : ' -70%'
                                    }
                                    :
                                    windowSize.width < 920 ?
                                        {
                                            position: 'absolute',
                                            transition: 'all 1s',
                                            zIndex: 10,
                                            height: '100%',
                                            width: '50%',
                                            transform: windowSize.width < 920 ? 'translateY(-45px)' : 'none',
                                            left: showMenu ? '0' : ' -50%'
                                        }
                                        : { height: '100%', }}
                            >
                            </div>
                        </div>
                    </div>
                    <div className='search-container col-12 col-lg-8 mx-auto position-absolute text-center'>
                        <h1 className='search-title fw-normal text-white'>
                            Explore and find Artists
                        </h1>
                        <div className='mt-4 search-input col-10 d-flex flex-column-reverse flex-md-row justify-content-center align-items-center mx-auto'>
                            <div className="position-relative col-12 col-md-12 mb-4 left-input overflow-hidden">
                                <DebouncedSearchBoxArtist />
                                <div className='d-md-none blue-bg position-absolute p-4 cursor-pointer search-icon'>
                                    <BsSearch size={18} color={'#fff'} />
                                </div>
                            </div>

                        </div>
                        <div>
                            <Link href={'/my-shop'} passHref>
                                <a>
                                    <button className="btn btn-green w-auto">{isSeller ? 'Manage my profile' : 'Create profile'}</button>
                                </a>
                            </Link>
                        </div>

                    </div>
                    <div className='categories-container'>
                        <ul className='p-0 m-0 categories-list'>
                            {categoriesList?.map((value, index) => (
                                <li onClick={() => {
                                    if (currentSelectedCategory === value.value)
                                        setCurrentSelectedCategory("");
                                    else
                                        setCurrentSelectedCategory(value.value);
                                }} key={`${index}`} className='categories-item'>
                                    <div className='circle-wrapper' style={{ backgroundColor: currentSelectedCategory === value.value ? "#1478dd" : "" }}>
                                        {value.icon}
                                    </div>
                                    <div>
                                        <p className='mt-2 mb-0 text-white'>{value.title}</p>
                                    </div>
                                </li>))}
                        </ul>
                    </div>
                    <div className='categories-container'>
                        <ul className='p-0 m-0 categories-list'>
                            {categoriesList?.map((value, index) => (
                                <li onClick={() => {
                                    if (currentSelectedCategory === value.value)
                                        setCurrentSelectedCategory("");
                                    else
                                        setCurrentSelectedCategory(value.value);
                                }} key={`${index}`} className='categories-item'>
                                    <div className='circle-wrapper' style={{ backgroundColor: currentSelectedCategory === value.value ? "#1478dd" : "" }}>
                                        {value.icon}
                                    </div>
                                    <div>
                                        <p className='mt-2 mb-0 text-white'>{value.title}</p>
                                    </div>
                                </li>))}
                        </ul>
                    </div>
                </div>

                <div className='artist-container d-lg-flex justify-content-center py-4'>
                    <div className='col-10 col-lg-3 mx-auto mb-4 mb-lg-0 mt-15'>
                        {/* <p className='filter-title'>Listings in {activeFilterSection}</p> */}
                        <CustomHierarchicalMenuArtists
                            attributes={["categoryHierarchy.lvl0", "categoryHierarchy.lvl1", "categoryHierarchy.lvl2"]}
                            showParentLevel={true}
                            currentSelectedCategory={currentSelectedCategory}
                            setCurrentSelectedCategory={(e) => setCurrentSelectedCategory(e)}
                        />
                    </div>

                    <Configure
                        hitsPerPage={20}
                        facetFilters={facetFilters}
                    />

                    <div className='d-flex justify-content-center col-lg-8 '>
                        <InfiniteHits 
                            agency={agency}
                            agencyId={agencyId} 
                            currentSelectedCategory={currentSelectedCategory}
                            setCurrentSelectedCategory={(e) => setCurrentSelectedCategory(e)}
                        />
                    </div>

                </div>

            </Container >
        </ArtistSearchProvider>
    );
}

const baseUrl = fleatoConfig.websiteBaseUrl;
export async function getStaticPaths() {
  // Return a list of possible value for id
  let agencyIds = [];
  return { paths: agencyIds, fallback: "blocking" };
}

export async function getStaticProps({ params }) {
  // Fetch necessary data for the blog post using params.id
  const { id } = params;
  try {
    const result = await fetch(`${baseUrl}/api/agency/${id}`);
    const agency = await result.json();
    return {
      props: {
        agency,
        revalidate: 10,
      },
    };
  } catch (err) {
    return {
      props: {
        agency: null,
        revalidate: 10,
      },
    };
  }
}